<!-- Alert Component: se posiciona solo (position: fixed en su CSS) -->
@if (show) {
<div (click)="handleToastClick()" class="cursor-pointer">
  <app-alert [title]="toastTitle" [message]="toastMessage" [type]="toastType" [duration]="3000">
  </app-alert>
</div>
}

@if (isOpen && isMobile) {
<div class="fixed inset-0 bg-[var(--color-gray-200)]/70 dark:bg-[var(--color-dark-bg-primary)]/70 z-[1990]"
  (click)="toggleSidebar()" aria-hidden="true"></div>
}

<!-- sidebar-menu.component.html -->
<div
  class="fixed inset-y-0 w-72 text-[var(--color-text-400)] border-r border-[var(--color-gray-100)] bg-[var(--color-brand-200)] z-[2000] shadow-sm flex flex-col h-full dark:bg-[var(--color-dark-bg-secondary)] dark:border-[var(--color-gray-900)] dark:text-[var(--color-white)]"
  [ngClass]="{
    '-translate-x-full': !isOpen,
    'translate-x-0': isOpen,
    'left-14': !isMobile && !isMenuExpanded,
    'left-64': !isMobile && isMenuExpanded,
    'left-0': isMobile
  }">
  @if (isMobile) {
  <div class="flex items-center justify-between px-4 pt-4 pb-2">
    <span class="text-sm font-semibold text-[var(--color-text-300)] dark:text-[var(--color-white)]">
      Chats
    </span>
    <button
      type="button"
      class="w-9 h-9 rounded-xl bg-white/85 dark:bg-[var(--color-dark-bg-primary)]/80 border border-[var(--color-gray-200)] dark:border-[var(--color-dark-bg-tertiary)] flex items-center justify-center text-[var(--color-text-300)] dark:text-[var(--color-white)] cursor-pointer"
      (click)="toggleSidebar($event)"
      aria-label="Cerrar menú de chats"
    >
      <fa-icon [icon]="faArrowLeft" class="text-sm"></fa-icon>
    </button>
  </div>
  }

  <!--
  <div class="flex items-center justify-between p-6 border-[var(--color-gray-200)] flex-shrink-0">
    <div id="agent-selector-container" class="relative dark:text-[var(--color-white)]">
      <div class="cursor-pointer flex items-center" (click)="toggleDropdownAgent($event)">
        <fa-icon [icon]="getCurrentAgentIcon()" class="mr-3 text-xl"></fa-icon>
        <span class="text-xl font-extrabold truncate max-w-[140px]">{{
          agent.name
          }}</span>
        <fa-icon [icon]="faAngleDown" class="ml-4"></fa-icon>
      </div>

      @if (isDropdownAgentOpen) {
      <div
        class="absolute left-0 right-0 top-full mt-1 w-96 bg-[var(--color-brand-200)] shadow-md rounded-lg border border-[var(--color-gray-200)] z-[60] dark:bg-[var(--color-neutral-800)] dark:border-none">
        <h3
          class="text-sm text-[var(--color-black)] tracking-wider px-4 pt-4 pb-2 dark:text-[var(--color-white)] font-medium">
          Todos los agentes
        </h3>

        Barra de búsqueda
        <div class="px-4 pb-3">
          <div class="relative">
            <input type="text" placeholder="Buscar agentes..." autofocus [(ngModel)]="agentSearchQuery"
              (input)="onAgentSearchChange()" (click)="$event.stopPropagation()"
              class="w-full pl-8 pr-3 py-1.5 text-sm border border-[var(--color-gray-300)] dark:border-[var(--color-neutral-600)] rounded-lg
                       bg-[var(--color-white)] dark:bg-[var(--color-neutral-700)] text-[var(--color-gray-900)] dark:text-[var(--color-white)]
                       placeholder-[var(--color-gray-500)] dark:placeholder-[var(--color-gray-400)] focus:outline-none focus:ring-1 focus:ring-[var(--color-brand-500)]" />
            <div class="absolute inset-y-0 left-0 pl-2.5 flex items-center pointer-events-none">
              <svg class="h-4 w-4 text-[var(--color-gray-400)]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
              </svg>
            </div>
          </div>
        </div>

        <div class="max-h-64 overflow-y-auto sidebar-scrollbar">
          <ul class="py-2">
            @for (product of filteredProducts; track product.agent_config.name || product.id) {
            <li>
              <button
                class="block w-full text-left px-4 py-2 hover:bg-[var(--color-brand-500)] cursor-pointer dark:hover:bg-[var(--color-white)]/10"
                (click)="selectAgent(product)">
                <fa-icon [icon]="getAgentIcon(product)" class="pr-1"></fa-icon>
                {{ product.agent_config.name }}
              </button>
            </li>
            }
            @empty {
            <li class="px-4 py-2 text-gray-500">
              No hay agentes con ese nombre
            </li>
            }
          </ul>
        </div>
      </div>
      }
    </div>

    <button type="button" title="Nuevo chat" aria-label="Crear nuevo chat" (click)="newChat()"
      class="text-[var(--color-gray-700)] hover:text-[var(--color-black)] dark:text-[var(--color-white)] dark:hover:text-[var(--color-white)] text-xl cursor-pointer">
      <fa-icon [icon]="faPenToSquare"></fa-icon>
    </button>

  </div>
  -->

  <!-- Ver todos los agentes -->
  <div class="flex-shrink-0 pb-6 pt-6 px-3">
    <button
      class="w-full flex flex-row items-center px-4 py-2 gap-3 bg-white rounded-xl text-sm hover:text-[var(--color-brand-500)] cursor-pointer group dark:bg-gray-800 dark:hover:bg-gray-700 dark:text-white text-[var(--color-text-300)] mb-2 view-all-button"
      title="Volver a todos los agentes" (click)="goToAllAgents()">
      <span class="font-medium">Ver todos los agentes</span>
    </button>

    <!-- Nuevo chat -->
    <button class="w-full flex flex-row items-center px-4 py-3 gap-3 rounded-xl text-sm cursor-pointer new-chat-button"
      [ngClass]="{ 'new-chat-button-hover': isNewChatHovered }" (mouseenter)="isNewChatHovered = true"
      (mouseleave)="isNewChatHovered = false" title="Crear nuevo chat" (click)="newChat()">
      <fa-icon [icon]="faCirclePlus" class="new-chat-icon"
        [ngClass]="{ 'new-chat-icon-hover': isNewChatHovered }"></fa-icon>
      <span class="font-medium">Nuevo chat</span>
    </button>
  </div>

  <div class="flex-shrink-0">
    <h3 class="text-md text-[var(--color-black)] px-4 dark:text-[var(--color-white)] font-semibold">
      Todos los chats
    </h3>
  </div>

  <div class="px-2 flex-shrink-0 border-[var(--color-gray-100)]">
    <button
      class="w-full text-sm font-semibold text-left p-2 rounded-xl text-[var(--color-text-300)] hover:bg-[var(--color-brand-400)] hover:text-[var(--color-text-100)] cursor-pointer group dark:hover:bg-[var(--color-white)]/10 dark:text-[var(--color-white)]"
      (click)="openSearch()">
      <fa-icon [icon]="faSearch"
        class="text-[var(--color-text-300)] group-hover:text-[var(--color-text-100)] pl-1 pr-2 dark:text-[var(--color-white)]"></fa-icon>
      Buscar chats
    </button>
  </div>

  <div class="flex-grow flex flex-col min-h-0">
    <nav #sidebarScrollContainer class="pb-4 pt-6 px-2 sm:pr-2 overflow-y-auto h-full sidebar-scrollbar dark:text-[var(--color-white)]"
      (scroll)="onScroll($event)">
      <div class="px-2 mb-4">
        <div class="flex items-center justify-between px-2">
          <h3
            class="text-xs font-semibold text-[var(--color-gray-600)] uppercase tracking-wider dark:text-[var(--color-gray-400)]">
            Carpetas
          </h3>
          <button type="button"
            class="text-xs font-semibold text-[var(--color-brand-500)] hover:text-[var(--color-brand-600)] dark:text-[var(--color-brand-300)] dark:hover:text-[var(--color-brand-200)] cursor-pointer"
            (click)="openCreateGroupModal()">
            + Nueva carpeta
          </button>
        </div>

        <div class="mt-3 flex items-center justify-between px-2">
          <button
            class="text-xs font-semibold text-[var(--color-text-300)] hover:text-[var(--color-brand-500)]"
            (click)="toggleSelectionMode()">
            {{ selectionMode ? 'Cancelar selección' : 'Seleccionar' }}
          </button>
          @if (selectionMode) {
          <button
            class="text-xs font-semibold text-[var(--color-brand-500)] hover:text-[var(--color-brand-600)]"
            (click)="openBulkMoveModal()">
            Mover ({{ selectedChatIds.size }})
          </button>
          }
        </div>
      </div>

      @for (group of chatGroupsList; track group.id) {
      <div class="mb-3">
        <div
          class="flex items-center justify-between px-2 py-2 rounded-lg cursor-pointer border border-transparent"
          [ngClass]="{
            'bg-[var(--color-brand-100)] dark:bg-[var(--color-white)]/10 border-[var(--color-brand-200)]': dragOverGroupId === group.id
          }"
          draggable="true"
          (dragstart)="onGroupDragStart(group, $event)"
          (dragover)="onGroupDragOver($event, group.id)"
          (drop)="onGroupDrop($event, group)"
          (dragend)="onGroupDragEnd()"
        >
          <div class="flex items-center gap-2 flex-1 min-w-0">
            <button
              class="w-6 h-6 flex items-center justify-center rounded-lg hover:bg-[var(--color-brand-100)] dark:hover:bg-[var(--color-white)]/10"
              (click)="toggleGroupExpanded(group, $event)">
              <fa-icon
                [icon]="chatGroupExpanded[group.id] ? faChevronDown : faChevronRight"
                class="text-xs text-[var(--color-gray-500)]"
              ></fa-icon>
            </button>
            <button
              class="flex items-center gap-2 flex-1 min-w-0 text-left cursor-pointer"
              (click)="openGroupView(group, $event)">
              <span
                class="w-6 h-6 rounded-lg flex items-center justify-center text-xs text-white shrink-0"
                [ngStyle]="{ background: group.color || 'var(--color-brand-400)' }">
                @if (getGroupIconDisplay(group.icon)) {
                <span>{{ getGroupIconDisplay(group.icon) }}</span>
                } @else {
                <fa-icon
                  [icon]="getGroupIconFa(group.icon, chatGroupExpanded[group.id])"
                  class="text-xs text-white"
                ></fa-icon>
                }
              </span>
              <span class="text-sm font-medium text-[var(--color-gray-800)] dark:text-[var(--color-white)] truncate">
                {{ group.name }}
              </span>
              <span class="text-xs text-[var(--color-gray-500)] dark:text-[var(--color-gray-400)] ml-auto">
                {{ group.chats_count || 0 }}
              </span>
            </button>
          </div>

          <div class="relative">
            <fa-icon [icon]="faEllipsis" class="text-[var(--color-brand-300)] px-1"
              (click)="toggleGroupOptions(group.id, $event)"></fa-icon>
            @if (groupOptionsOpen[group.id]) {
            <div
              class="absolute right-0 top-4 mr-2 w-44 bg-[var(--color-brand-100)] shadow-lg rounded-xl p-2 z-[90] dark:bg-[var(--color-dark-bg-primary)] border border-[var(--color-gray-100)] dark:border-[var(--color-dark-bg-tertiary)]">
              <ul class="space-y-1">
                <li>
                  <button
                    class="w-full text-sm text-left px-3 py-2 hover:bg-[var(--color-gray-100)] rounded-xl cursor-pointer text-[var(--color-text-400)] dark:text-[var(--color-white)] dark:hover:bg-[var(--color-white)]/10"
                    (click)="openEditGroupModal(group, $event)">
                    <fa-icon [icon]="faPen" class="pr-2"></fa-icon>
                    Editar
                  </button>
                </li>
                <li>
                  <button
                    class="w-full text-sm text-left px-3 py-2 hover:bg-[var(--color-error-400)] hover:text-[var(--color-error-700)] rounded-xl cursor-pointer text-[var(--color-text-400)] dark:text-[var(--color-white)] dark:hover:bg-[var(--color-error-500)]/20 dark:hover:text-[var(--color-error-500)]"
                    (click)="requestDeleteGroup(group, $event)">
                    <fa-icon [icon]="faTrash" class="pr-2"></fa-icon>
                    Eliminar
                  </button>
                </li>
              </ul>
            </div>
            }
          </div>
        </div>

        @if (chatGroupExpanded[group.id]) {
        <div class="ml-8 mt-2 space-y-2">
          <button type="button"
            class="text-xs font-semibold text-[var(--color-brand-500)] hover:text-[var(--color-brand-600)] cursor-pointer"
            (click)="startNewChatInGroup(group, $event)">
            + Nuevo chat
          </button>

          @if (chatGroupLoading[group.id]) {
          <div class="flex items-center justify-center pr-6">
            <app-loader label="Cargando..." size="sm"></app-loader>
          </div>
          }

          @if (!chatGroupLoading[group.id] && ((chatGroupChats[group.id] || []).length) === 0) {
          <div class="text-xs text-[var(--color-gray-500)] dark:text-[var(--color-gray-400)] px-2">
            Sin chats en esta carpeta.
          </div>
          }

          <ul class="space-y-1">
            @for (item of chatGroupChats[group.id]; track item.chat_id) {
            <li class="relative" [ngClass]="{ active: item.active }" draggable="true"
              (dragstart)="onChatDragStart(item, group.id)" (dragend)="onChatDragEnd()">
              <button
                class="relative flex items-center w-full py-1 pr-2 text-left text-sm rounded-lg hover:bg-[var(--color-brand-400)] hover:text-[var(--color-text-100)] cursor-pointer group dark:hover:bg-[var(--color-white)]/10"
                [ngClass]="{
                  'bg-[var(--color-brand-400)] dark:bg-[var(--color-neutral-800)] text-[var(--color-text-100)]': item.active
                }"
                [title]="item.label"
                (click)="selectionMode ? toggleChatSelection(item, $event) : selectItem(item)">
                @if (selectionMode) {
                <input type="checkbox" class="mx-2" [checked]="isChatSelected(item)"
                  (click)="toggleChatSelection(item, $event)" />
                }
                <fa-icon [icon]="getChatIcon(item)" class="mx-2 text-xs"></fa-icon>
                <span class="flex-grow text-truncate-mask font-normal pr-8">
                  {{ item.label }}
                </span>
                @if (item.isProcessing) {
                <span class="ml-2 pr-3 inline-flex items-center" title="Respuesta en progreso">
                  <span
                    class="w-3 h-3 rounded-full border-2 border-t-transparent animate-spin"
                    [ngClass]="item.active
                      ? 'border-white/90 bg-white/10'
                      : 'border-[var(--color-brand-400)]'"></span>
                </span>
                }
                @if (isChatMoving(item)) {
                <span class="absolute right-2 top-1/2 -translate-y-1/2 inline-flex items-center" title="Moviendo chat...">
                  <span
                    class="w-3 h-3 rounded-full border-2 border-t-transparent animate-spin"
                    [ngClass]="item.active
                      ? 'border-white/90 bg-white/10'
                      : 'border-[var(--color-brand-600)] dark:border-[var(--color-brand-300)]'"></span>
                </span>
                }
                @if (!isChatMoving(item)) {
                <div class="relative">
                  <fa-icon [icon]="faEllipsis" [class]="
                            isSmallScreen
                              ? 'px-1 absolute right-2 top-1/2 transform -translate-y-1/2 text-[var(--color-brand-300)] transition-all dark:text-[var(--color-brand-300)]'
                              : 'px-1 absolute right-2 top-1/2 transform -translate-y-1/2 text-[var(--color-brand-300)] transition-all dark:text-[var(--color-brand-300)] hidden group-hover:block'
                          " (click)="toggleChatOptions(item.chat_id, $event)"></fa-icon>

                  @if (chatOptionsOpen[item.chat_id]) {
                  <div
                    [ngClass]="showDropdownUp
                                ? 'absolute right-0 bottom-4 mr-2 w-48 bg-[var(--color-brand-100)] shadow-lg rounded-xl p-2 z-[90] dark:bg-[var(--color-dark-bg-primary)] dark:text-[var(--color-white)] border border-[var(--color-gray-100)] dark:border-[var(--color-dark-bg-tertiary)]'
                                : 'absolute right-0 top-4 mr-2 w-48 bg-[var(--color-brand-100)] shadow-lg rounded-xl p-2 z-[90] dark:bg-[var(--color-dark-bg-primary)] dark:text-[var(--color-white)] border border-[var(--color-gray-100)] dark:border-[var(--color-dark-bg-tertiary)]'">
                    <ul class="space-y-1">
                      <li>
                        <button
                          class="w-full text-sm text-left px-3 py-2 hover:bg-[var(--color-gray-100)] hover:text-[var(--color-text-400)] rounded-xl cursor-pointer text-[var(--color-text-400)] dark:text-[var(--color-white)] dark:hover:bg-[var(--color-white)]/10 dark:hover:text-[var(--color-white)]"
                          (click)="openMoveChatModalForChat(item, $event)">
                          <fa-icon [icon]="faArrowTurnDownLeft" class="pr-2"></fa-icon>
                          Mover a carpeta
                        </button>
                      </li>
                      <li>
                        <button
                          class="w-full text-sm text-left px-3 py-2 hover:bg-[var(--color-gray-100)] hover:text-[var(--color-text-400)] rounded-xl cursor-pointer text-[var(--color-text-400)] dark:text-[var(--color-white)] dark:hover:bg-[var(--color-white)]/10 dark:hover:text-[var(--color-white)]"
                          (click)="removeChatFromGroup(item, $event)">
                          <fa-icon [icon]="faRightFromBracket" class="pr-2"></fa-icon>
                          Sacar de carpeta
                        </button>
                      </li>
                      <li>
                        <button
                          class="w-full text-sm text-left px-3 py-2 hover:bg-[var(--color-gray-100)] hover:text-[var(--color-text-400)] rounded-xl cursor-pointer text-[var(--color-text-400)] dark:text-[var(--color-white)] dark:hover:bg-[var(--color-white)]/10 dark:hover:text-[var(--color-white)]"
                          (click)="archiveChat(item.chat_id, $event)">
                          <fa-icon [icon]="faRightFromBracket" class="pr-2"></fa-icon>
                          Archivar
                        </button>
                      </li>
                      <li>
                        <button
                          class="w-full text-sm text-left px-3 py-2 hover:bg-[var(--color-error-400)] hover:text-[var(--color-error-700)] rounded-xl cursor-pointer text-[var(--color-text-400)] dark:text-[var(--color-white)] dark:hover:bg-[var(--color-error-500)]/20 dark:hover:text-[var(--color-error-500)]"
                          (click)="toggleDeleteConfirmation(item.chat_id, $event)">
                          <fa-icon [icon]="faTrash" class="pr-2"></fa-icon>
                          Eliminar
                        </button>
                      </li>
                    </ul>
                  </div>
                  }
                </div>
                }
              </button>
            </li>
            }
          </ul>

          @if (chatGroupPagination[group.id] && chatGroupPagination[group.id].current_page < chatGroupPagination[group.id].last_page) {
          <div class="mt-2 flex justify-start pl-2">
            <button
              class="text-xs font-semibold text-[var(--color-brand-500)] hover:text-[var(--color-brand-600)]"
              [disabled]="chatGroupLoading[group.id]"
              (click)="loadMoreGroupChats(group.id)">
              {{ chatGroupLoading[group.id] ? 'Cargando...' : 'Cargar más' }}
            </button>
          </div>
          }
        </div>
        }
      </div>
      }

      <div class="mt-4">
        <div class="flex items-center justify-between px-2">
          <h3
            class="text-xs font-semibold text-[var(--color-gray-600)] uppercase tracking-wider dark:text-[var(--color-gray-400)]">
            Sin carpeta
          </h3>
          <span class="text-xs text-[var(--color-gray-500)] dark:text-[var(--color-gray-400)]">
            {{ paginationData.total || chatGroupStats.total_chats_without_group || 0 }}
          </span>
        </div>

        <div class="mt-2 px-2 py-2 rounded-lg border border-transparent"
          [ngClass]="{
            'bg-[var(--color-brand-100)] dark:bg-[var(--color-white)]/10 border-[var(--color-brand-200)]': dragOverGroupId === -1
          }"
          (dragover)="onGroupDragOver($event, -1)"
          (drop)="onUngroupedDrop($event)">
          <ul class="space-y-1">
            @for (item of ungroupedChats; track item.chat_id) {
            <li class="relative" [ngClass]="{ active: item.active }" draggable="true"
              (dragstart)="onChatDragStart(item, null)" (dragend)="onChatDragEnd()">
              <button
                class="relative flex items-center w-full py-1 pr-2 text-left text-sm rounded-lg hover:bg-[var(--color-brand-400)] hover:text-[var(--color-text-100)] cursor-pointer group dark:hover:bg-[var(--color-white)]/10"
                [ngClass]="{
                  'bg-[var(--color-brand-400)] dark:bg-[var(--color-neutral-800)] text-[var(--color-text-100)]': item.active
                }"
                [title]="item.label"
                (click)="selectionMode ? toggleChatSelection(item, $event) : selectItem(item)">
                @if (selectionMode) {
                <input type="checkbox" class="mx-2" [checked]="isChatSelected(item)"
                  (click)="toggleChatSelection(item, $event)" />
                }
                <fa-icon [icon]="getChatIcon(item)" class="mx-2 text-xs"></fa-icon>
                <span class="flex-grow text-truncate-mask font-normal pr-8">
                  {{ item.label }}
                </span>
                @if (item.isProcessing) {
                <span class="ml-2 pr-3 inline-flex items-center" title="Respuesta en progreso">
                  <span
                    class="w-3 h-3 rounded-full border-2 border-t-transparent animate-spin"
                    [ngClass]="item.active
                      ? 'border-white/90 bg-white/10'
                      : 'border-[var(--color-brand-400)]'"></span>
                </span>
                }
                @if (isChatMoving(item)) {
                <span class="absolute right-2 top-1/2 -translate-y-1/2 inline-flex items-center" title="Moviendo chat...">
                  <span
                    class="w-3 h-3 rounded-full border-2 border-t-transparent animate-spin"
                    [ngClass]="item.active
                      ? 'border-white/90 bg-white/10'
                      : 'border-[var(--color-brand-600)] dark:border-[var(--color-brand-300)]'"></span>
                </span>
                }
                @if (!isChatMoving(item)) {
                <div class="relative">
                  <fa-icon [icon]="faEllipsis" [class]="
                            isSmallScreen
                              ? 'px-1 absolute right-2 top-1/2 transform -translate-y-1/2 text-[var(--color-brand-300)] transition-all dark:text-[var(--color-brand-300)]'
                              : 'px-1 absolute right-2 top-1/2 transform -translate-y-1/2 text-[var(--color-brand-300)] transition-all dark:text-[var(--color-brand-300)] hidden group-hover:block'
                          " (click)="toggleChatOptions(item.chat_id, $event)"></fa-icon>

                  @if (chatOptionsOpen[item.chat_id]) {
                  <div
                    [ngClass]="showDropdownUp
                                ? 'absolute right-0 bottom-4 mr-2 w-48 bg-[var(--color-brand-100)] shadow-lg rounded-xl p-2 z-[90] dark:bg-[var(--color-dark-bg-primary)] dark:text-[var(--color-white)] border border-[var(--color-gray-100)] dark:border-[var(--color-dark-bg-tertiary)]'
                                : 'absolute right-0 top-4 mr-2 w-48 bg-[var(--color-brand-100)] shadow-lg rounded-xl p-2 z-[90] dark:bg-[var(--color-dark-bg-primary)] dark:text-[var(--color-white)] border border-[var(--color-gray-100)] dark:border-[var(--color-dark-bg-tertiary)]'">
                    <ul class="space-y-1">
                      <li>
                        <button
                          class="w-full text-sm text-left px-3 py-2 hover:bg-[var(--color-gray-100)] hover:text-[var(--color-text-400)] rounded-xl cursor-pointer text-[var(--color-text-400)] dark:text-[var(--color-white)] dark:hover:bg-[var(--color-white)]/10 dark:hover:text-[var(--color-white)]"
                          (click)="openMoveChatModalForChat(item, $event)">
                          <fa-icon [icon]="faArrowTurnDownLeft" class="pr-2"></fa-icon>
                          Mover a carpeta
                        </button>
                      </li>
                      <li>
                        <button
                          class="w-full text-sm text-left px-3 py-2 hover:bg-[var(--color-gray-100)] hover:text-[var(--color-text-400)] rounded-xl cursor-pointer text-[var(--color-text-400)] dark:text-[var(--color-white)] dark:hover:bg-[var(--color-white)]/10 dark:hover:text-[var(--color-white)]"
                          (click)="archiveChat(item.chat_id, $event)">
                          <fa-icon [icon]="faRightFromBracket" class="pr-2"></fa-icon>
                          Archivar
                        </button>
                      </li>
                      <li>
                        <button
                          class="w-full text-sm text-left px-3 py-2 hover:bg-[var(--color-error-400)] hover:text-[var(--color-error-700)] rounded-xl cursor-pointer text-[var(--color-text-400)] dark:text-[var(--color-white)] dark:hover:bg-[var(--color-error-500)]/20 dark:hover:text-[var(--color-error-500)]"
                          (click)="toggleDeleteConfirmation(item.chat_id, $event)">
                          <fa-icon [icon]="faTrash" class="pr-2"></fa-icon>
                          Eliminar
                        </button>
                      </li>
                    </ul>
                  </div>
                  }
                </div>
                }
              </button>
            </li>
            }
          </ul>
          @if (showLoadMoreUngrouped) {
          <div class="mt-3 flex justify-center">
            <button
              class="text-xs font-semibold text-[var(--color-brand-500)] hover:text-[var(--color-brand-600)] px-3 py-2 rounded-lg hover:bg-[var(--color-brand-100)] dark:hover:bg-[var(--color-white)]/10"
              [disabled]="isLoadingChats"
              (click)="loadMoreChats()">
              {{ isLoadingChats ? 'Cargando...' : 'Cargar más' }}
            </button>
          </div>
          }
        </div>
      </div>

      <div class="px-2">
        @if (isLoadingChats) {
        <div class="flex items-center justify-center pr-6">
          <app-loader label="Cargando..." size="sm"></app-loader>
        </div>
        }
        @if (!hasMorePages && !isLoadingChats && paginationData.total > 0) {
        <div class="text-xs text-[var(--color-neutral-600)] text-start dark:text-[var(--color-neutral-400)]">
          ¡No tienes más chats!
        </div>
        }
      </div>
    </nav>
  </div>

  <!-- Menú de perfil para móviles deshabilitado temporalmente
  <div class="flex-shrink-0 border-[var(--color-gray-100)] py-2" [ngClass]="{'hidden': !isMobile}">
    <div
      class="mx-4 mb-2 flex items-center justify-between bg-[var(--color-brand-500)] rounded-3xl py-3 px-3 relative dark:bg-[var(--color-dark-bg-primary)] cursor-pointer"
      (click)="toggleProfileMenu($event)">
      <div class="flex items-center space-x-2">
        <div class="flex items-center justify-center w-10 h-10 bg-[var(--color-brand-100)] rounded-full flex-shrink-0">
          <fa-icon [icon]="faUser" class="text-[var(--color-brand-500)]"></fa-icon>
        </div>
        @if (userInfo.name) {
          <div class="max-w-[140px] text-[var(--color-black)] dark:text-[var(--color-white)]">
            <p class="font-medium truncate">{{ userInfo.name }}</p>
            <p class="text-sm truncate">{{ userInfo.company.name }}</p>
          </div>
        }
      </div>
      <fa-icon [icon]="isProfileMenuOpen ? faAngleUp : faAngleDown"
        class="text-[var(--color-gray-600)] px-3 dark:text-[var(--color-white)]"></fa-icon>


      @if (isProfileMenuOpen) {
        <div
          class="absolute bottom-full left-0 right-0 bg-[var(--color-brand-200)] shadow-md rounded-xl p-2 my-2 z-10 dark:bg-[var(--color-dark-bg-primary)] dark:text-[var(--color-white)]">
          <ul class="space-y-2">
            <li>
              <button
                class="w-full text-sm text-left px-3 py-2 hover:bg-[var(--color-brand-100)] rounded-xl cursor-pointer dark:hover:bg-[var(--color-white)]/10"
                (click)="openProfile()">
                <fa-icon [icon]="faUser" class="pr-2"></fa-icon>
                Perfil
              </button>
            </li>
            <li>
              <button
                class="w-full text-sm text-left px-3 py-2 hover:bg-[var(--color-brand-100)] rounded-xl cursor-pointer dark:hover:bg-[var(--color-white)]/10"
                (click)="openSettings()">
                <fa-icon [icon]="faGear" class="pr-2"></fa-icon>
                Configuración
              </button>
            </li>
            <li>
              <button
                class="w-full text-sm text-left px-4 py-2 hover:bg-[var(--color-brand-100)] rounded-xl cursor-pointer dark:hover:bg-[var(--color-white)]/10"
                (click)="logout()">
                <fa-icon [icon]="faRightFromBracket" class="pr-2"></fa-icon>
                Cerrar sesión
              </button>
            </li>
          </ul>
        </div>
      }

    </div>
  </div>
  -->
</div>



<!-- Modal: Eliminar chat -->
<app-confirm-modal [show]="!!chatToDelete" title="¿Eliminar chat?" message="Esta acción no se puede deshacer."
  icon="danger" confirmText="Eliminar" confirmStyle="danger" (confirm)="confirmDeleteChat()"
  (cancel)="chatToDelete = null">
</app-confirm-modal>

<!-- Modal: Archivar chat -->
<app-confirm-modal [show]="!!chatToArchive" title="¿Archivar chat?"
  message="El chat se archivará y podrás acceder a él desde la sección de chats archivados." icon="info"
  confirmText="Archivar" confirmStyle="primary" (confirm)="confirmArchiveChat()" (cancel)="chatToArchive = null">
</app-confirm-modal>

<!-- Modal: Eliminar carpeta -->
<app-confirm-modal [show]="!!groupToDelete" title="¿Eliminar carpeta?"
  message="Los chats dentro no se borrarán y pasarán a Sin carpeta." icon="warning"
  confirmText="Eliminar" confirmStyle="danger" (confirm)="confirmDeleteGroup()"
  (cancel)="groupToDelete = null">
</app-confirm-modal>

<!-- Modal: Crear / Editar carpeta -->
@if (showGroupModal) {
<div class="fixed inset-0 bg-black/40 z-[9998]" (click)="closeGroupModal()"></div>
<div class="fixed inset-0 z-[9999] flex items-center justify-center px-4" (click)="closeGroupModal()">
  <div
    class="bg-[var(--color-white)] dark:bg-[var(--color-dark-bg-secondary)] rounded-2xl shadow-lg w-full max-w-md p-6"
    (click)="$event.stopPropagation()">
    <h3 class="text-lg font-semibold text-[var(--color-gray-800)] dark:text-[var(--color-white)] mb-4">
      {{ isEditingGroup ? 'Editar carpeta' : 'Nueva carpeta' }}
    </h3>
    <form (ngSubmit)="saveGroup()" class="space-y-4">
      <div>
        <label class="text-sm font-medium text-[var(--color-gray-600)] dark:text-[var(--color-gray-300)]">Nombre</label>
        <input
          type="text"
          name="groupName"
          [(ngModel)]="groupForm.name"
          class="mt-2 w-full h-11 px-4 rounded-xl border border-[var(--color-gray-200)] dark:border-[var(--color-white)]/10 bg-white dark:bg-[var(--color-dark-bg-primary)] text-sm text-[var(--color-gray-800)] dark:text-[var(--color-white)] placeholder:text-[var(--color-gray-400)] dark:placeholder:text-[var(--color-gray-500)]"
          placeholder="Ej. Finanzas"
          maxlength="255"
          required
        />
      </div>
      <div>
        <label class="text-sm font-medium text-[var(--color-gray-600)] dark:text-[var(--color-gray-300)]">Descripción (opcional)</label>
        <textarea
          name="groupDescription"
          [(ngModel)]="groupForm.description"
          class="mt-2 w-full px-4 py-3 rounded-xl border border-[var(--color-gray-200)] dark:border-[var(--color-white)]/10 bg-white dark:bg-[var(--color-dark-bg-primary)] text-sm min-h-[90px] text-[var(--color-gray-800)] dark:text-[var(--color-white)] placeholder:text-[var(--color-gray-400)] dark:placeholder:text-[var(--color-gray-500)]"
          placeholder="Breve descripción"
        ></textarea>
      </div>
      <div class="flex justify-end gap-3 pt-2">
        <button type="button" class="text-sm font-semibold text-[var(--color-gray-500)] hover:text-[var(--color-gray-700)] dark:text-[var(--color-gray-300)] dark:hover:text-[var(--color-white)]"
          (click)="closeGroupModal()">Cancelar</button>
        <button type="submit"
          class="px-4 py-2 rounded-xl text-sm font-semibold bg-[var(--color-brand-400)] text-white hover:bg-[var(--color-brand-500)] disabled:opacity-60"
          [disabled]="isSavingGroup || !groupForm.name.trim()">
          {{ isEditingGroup ? 'Guardar' : 'Crear' }}
        </button>
      </div>
    </form>
  </div>
</div>
}

<!-- Modal: Mover chats -->
@if (showMoveChatModal) {
<div class="fixed inset-0 bg-black/40 z-[9998]" (click)="closeMoveChatModal()"></div>
<div class="fixed inset-0 z-[9999] flex items-center justify-center px-4" (click)="closeMoveChatModal()">
  <div
    class="bg-[var(--color-white)] dark:bg-[var(--color-dark-bg-secondary)] rounded-2xl shadow-lg w-full max-w-md p-6"
    (click)="$event.stopPropagation()">
    <h3 class="text-lg font-semibold text-[var(--color-gray-800)] dark:text-[var(--color-white)] mb-4">
      Mover chats
    </h3>
    <div class="space-y-4">
      <div>
        <label class="text-sm font-medium text-[var(--color-gray-600)] dark:text-[var(--color-gray-300)]">Carpeta destino</label>
        <select
          name="moveChatGroup"
          [(ngModel)]="moveChatTargetGroupId"
          class="mt-2 w-full h-11 px-4 rounded-xl border border-[var(--color-gray-200)] dark:border-[var(--color-white)]/10 bg-white dark:bg-[var(--color-dark-bg-primary)] text-sm">
          <option [ngValue]="null">Sin carpeta</option>
          @for (group of chatGroupsList; track group.id) {
          <option [ngValue]="group.id">{{ group.name }}</option>
          }
        </select>
      </div>
      <div class="flex justify-end gap-3 pt-2">
        <button type="button" class="text-sm font-semibold text-[var(--color-gray-500)] hover:text-[var(--color-gray-700)]"
          (click)="closeMoveChatModal()">Cancelar</button>
        <button type="button"
          class="px-4 py-2 rounded-xl text-sm font-semibold bg-[var(--color-brand-400)] text-white hover:bg-[var(--color-brand-500)]"
          (click)="confirmMoveChat()">
          Mover
        </button>
      </div>
    </div>
  </div>
</div>
}

<!-- Modal: Cerrar sesión -->
<app-confirm-modal [(show)]="showLogoutConfirmation" title="¿Estás seguro?" message="¿Deseas cerrar tu sesión?"
  icon="warning" confirmText="Cerrar sesión" confirmStyle="danger" (confirm)="confirmLogout()"
  (cancel)="cancelLogout()">
</app-confirm-modal>
